'use client';

import { ReactNode } from 'react';

interface StepWrapperProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function StepWrapper({ title, subtitle, children }: StepWrapperProps) {
  return (
    <div className="space-y-6">
      {/* Title/subtitle: visible on mobile only, hidden on desktop (shown in left panel) */}
      <div className="text-center space-y-2 lg:hidden">
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {subtitle && (
          <p className="text-muted-foreground text-sm max-w-md mx-auto">{subtitle}</p>
        )}
      </div>
      {children}
    </div>
  );
}
